import { Breadcrumbs, ContentLayout } from 'components/Layout';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { searchCustomers } from '../api/searchCustomers';
import { Spinner } from 'components/Elements';

export const SearchResults = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('query');
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [customerId, setCustomerId] = useState(0);

  useEffect(() => {
    if (query) {
      console.log(query);
      fetchSearchResults(query);
    }
  }, [query]);

  const fetchSearchResults = async (searchTerm) => {
    setLoading(true);
    setError(null);
    try {
      const data = {
        text: searchTerm,
        customerId,
      };
      const response = await searchCustomers(data);
      setCustomers(response.users);
    } catch (err) {
      setError('Failed to fetch search results.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentLayout title="Search Results" breadcrumbs={<Breadcrumbs />}>
      <div className="bg-white dark:bg-gray-900 shadow rounded-2xl p-4">
        {loading && (
          <div className="w-full h-48 flex justify-center items-center">
            <Spinner size="lg" />
          </div>
        )}

        {error && <p className="text-red-500">{error}</p>}
        {customers.length > 0 ? (
          <div className="flex flex-col space-y-2">
            {customers.map((customer) => (
              <Link
                key={customer.id}
                to={`/app/customers/details/${customer.id}`}
                className="p-4 border-b dark:border-gray-800"
              >
                <p className="font-bold">
                  {customer.firstName} {customer.lastName}
                </p>
                <p className="text-gray-600">{customer.email}</p>
              </Link>
            ))}
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </ContentLayout>
  );
};
